module.exports = __webpack_public_path__ + "images/canonical-card/confused-taco.88caed2d26de350cca5f.svg";